var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationTarget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z",
    fill: "#1F76FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.377 11H23C23.5523 11 24 11.4477 24 12C24 12.5523 23.5523 13 23 13H21.377C21.1316 13.0004 20.9228 13.1787 20.884 13.421C20.2641 17.2568 17.2568 20.2641 13.421 20.884C13.1787 20.9228 13.0004 21.1316 13 21.377V23C13 23.5523 12.5523 24 12 24C11.4477 24 11 23.5523 11 23V21.377C10.9996 21.1316 10.8213 20.9228 10.579 20.884C6.74321 20.2641 3.73588 17.2568 3.116 13.421C3.07723 13.1787 2.86837 13.0004 2.623 13H1C0.447715 13 0 12.5523 0 12C0 11.4477 0.447715 11 1 11H2.623C2.86837 10.9996 3.07723 10.8213 3.116 10.579C3.73588 6.74321 6.74321 3.73588 10.579 3.116C10.8213 3.07723 10.9996 2.86837 11 2.623V1C11 0.447715 11.4477 0 12 0C12.5523 0 13 0.447715 13 1V2.623C13.0004 2.86837 13.1787 3.07723 13.421 3.116C17.2568 3.73588 20.2641 6.74321 20.884 10.579C20.9228 10.8213 21.1316 10.9996 21.377 11ZM5 12C5 15.866 8.13401 19 12 19C15.8642 18.9956 18.9956 15.8642 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12Z",
    fill: "#1F76FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationTarget);
export default __webpack_public_path__ + "static/media/location-target.d0eca76f0d861d7abbf63150b518c925.svg";
export { ForwardRef as ReactComponent };